import { EasyLocale, easyLocale } from "../src/shared/store/easyLocale";
import { Window } from "../src/shared/types/global";

window.EasyLocale ||= {};

(window as any as Window).EasyLocale = easyLocale as EasyLocale;
